<template>
    <el-card>
        <div slot="header" class="move">
            <h3>Lead to Settlement</h3>
        </div>
        <el-table
            :data="leadToSettlementTotals"
            empty-text=" ">
            <el-table-column
                label="Leads"
                label-class-name="text-center"
                align="center">New
            </el-table-column>
            <el-table-column
                prop="leads_today"
                label="Today"
                label-class-name="text-center"
                align="center">
            </el-table-column>
            <el-table-column
                prop="leads_yesterday"
                label="Yesterday"
                label-class-name="text-center"
                align="center">
            </el-table-column>
            <el-table-column
                prop="leads_mtd"
                label="This Month"
                label-class-name="text-center"
                align="center">
            </el-table-column>
        </el-table>
        <el-table
            :data="leadToSettlementTotals"
            :show-header="false"
            empty-text=" ">
            <el-table-column
                align="center">No Contact
            </el-table-column>
            <el-table-column
                prop="nocontact_today"
                align="center">
            </el-table-column>
            <el-table-column
                prop="nocontact_yesterday"
                align="center">
            </el-table-column>
            <el-table-column
                prop="nocontact_mtd"
                align="center">
            </el-table-column>
        </el-table>
        <el-table
            :data="leadToSettlementTotals"
            :show-header="false"
            empty-text=" ">
            <el-table-column
                align="center">Junk
            </el-table-column>
            <el-table-column
                prop="junk_today"
                align="center">
            </el-table-column>
            <el-table-column
                prop="junk_yesterday"
                align="center">
            </el-table-column>
            <el-table-column
                prop="junk_mtd"
                align="center">
            </el-table-column>
        </el-table>
        <el-table
            :data="leadToSettlementTotals"
            :show-header="false"
            empty-text=" ">
            <el-table-column
                align="center"><strong>Apps</strong>
            </el-table-column>
            <el-table-column
                prop="apps_today"
                align="center">
            </el-table-column>
            <el-table-column
                prop="apps_yesterday"
                align="center">
            </el-table-column>
            <el-table-column
                prop="apps_mtd"
                align="center">
            </el-table-column>
        </el-table>
        <el-table
            :data="leadToSettlementTotals"
            :show-header="false"
            empty-text=" ">
            <el-table-column
                align="center"><strong>Approvals</strong>
            </el-table-column>
            <el-table-column
                prop="approvals_today"
                align="center">
            </el-table-column>
            <el-table-column
                prop="approvals_yesterday"
                align="center">
            </el-table-column>
            <el-table-column
                prop="approvals_mtd"
                align="center">
            </el-table-column>
        </el-table>
        <el-table
            :data="leadToSettlementTotals"
            :show-header="false"
            empty-text=" ">
            <el-table-column
                align="center"><strong>Options</strong>
            </el-table-column>
            <el-table-column
                prop="options_today"
                align="center">
            </el-table-column>
            <el-table-column
                prop="options_yesterday"
                align="center">
            </el-table-column>
            <el-table-column
                prop="options_mtd"
                align="center">
            </el-table-column>
        </el-table>
        <el-table
            :data="leadToSettlementTotals"
            :show-header="false"
            empty-text=" ">
            <el-table-column
                align="center"><strong>Settled</strong>
            </el-table-column>
            <el-table-column
                prop="settled_today"
                align="center">
            </el-table-column>
            <el-table-column
                prop="settled_yesterday"
                align="center">
            </el-table-column>
            <el-table-column
                prop="settled_mtd"
                align="center">
            </el-table-column>
        </el-table>
    </el-card>
</template>

<script>
import HorizontalBarChart from '../../ambition/dashboard/charts/HorizontalBarChart'

export default {
    name: 'LeadSettlementChart',
    components: {
        HorizontalBarChart
    },
    props: [
        'statsTotal',
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            leadToSettlementTotals: [],
        }
    },
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.leadToSettlementTotals = event.leadToSettlement.leadToSettlement.statsTotal

            this.graphColorChange()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.leadToSettlementTotals = event.leadToSettlement.leadToSettlement.statsTotal

            this.graphColorChange()
        })
    },
    computed: {},
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        }
    }
}
</script>

<style scoped>
.move {
    cursor: move;
}
</style>
